module.exports = __webpack_public_path__ + "static/media/ope_tiitta_480x640.e594d9c9.jpg";